'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('../../../components');
var _appendLocale = require('../../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

var _PhoneVerificationForm = require('../PhoneVerificationForm.scss');var styles = _interopRequireWildcard(_PhoneVerificationForm);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Styles
var PhoneNumberSection = function (_Component) {_inherits(PhoneNumberSection, _Component);function PhoneNumberSection() {var _temp, _this, _ret;_classCallCheck(this, PhoneNumberSection);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      isSubmitButtonShown: true,
      isSpinnerShown: false,
      isAgainSentShown: false }, _this.






























    fetchToken = function (token) {
      _this.props.fetchReCaptchaToken(token);
      _this.setState({
        isSpinnerShown: true });

    }, _this.

    errorMessage = function () {var _this$props =
      _this.props,translate = _this$props.translate,showErrorMessage = _this$props.showErrorMessage,errorMessage = _this$props.errorMessage,locale = _this$props.locale,phoneNumberAlreadyTaken = _this$props.phoneNumberAlreadyTaken;
      return !!showErrorMessage &&
      _react2.default.createElement('p', { className: styles.invalidMessage },
        errorMessage,
        phoneNumberAlreadyTaken &&
        _react2.default.createElement(_reactRouter.Link, { to: (0, _appendLocale2.default)(locale, '/contact') }, '\xA0',

          translate('contactUs')));




    }, _this.

    submitButton = function () {var _this$props2 =

      _this.props,locale = _this$props2.locale,fetchReCaptchaToken = _this$props2.fetchReCaptchaToken,doResetCaptcha = _this$props2.doResetCaptcha,showPhonePreloader = _this$props2.showPhonePreloader,translate = _this$props2.translate,showErrorMessage = _this$props2.showErrorMessage,errorMessage = _this$props2.errorMessage,phoneNumberAlreadyTaken = _this$props2.phoneNumberAlreadyTaken,sendPhoneNumber = _this$props2.sendPhoneNumber;
      return (
        _react2.default.createElement('div', { key: 'submitButton', className: styles.submitButton },
          _react2.default.createElement(_components.GoogleReCaptcha, {
              locale: locale,
              fetchToken: fetchReCaptchaToken,
              doReset: doResetCaptcha },

            _react2.default.createElement(_components.OMButtonWithPreloader, {
              showPreloader: showPhonePreloader,
              onClick: sendPhoneNumber,
              innerText: translate('submitButton') })),



          _this.errorMessage()));


    }, _this.

    notReceiveSmsMessage = function () {var _this$props3 =
      _this.props,translate = _this$props3.translate,locale = _this$props3.locale,doResetCaptcha = _this$props3.doResetCaptcha,sendPhoneNumber = _this$props3.sendPhoneNumber;
      var title = _this.state.isAgainSentShown ?
      _react2.default.createElement('span', { className: styles.sentTitle }, translate('sent')) :
      translate('sendAgain');

      return (
        _react2.default.createElement('div', { key: 'notReceiveMessage', className: styles.notReceiveMessage },
          translate('notReceiveSms'),
          _react2.default.createElement(_components.GoogleReCaptcha, {
              locale: locale,
              fetchToken: _this.fetchToken,
              doReset: doResetCaptcha },

            _react2.default.createElement('button', {
                disabled: _this.state.isSpinnerShown,
                onClick: sendPhoneNumber,
                className: styles.sendAgain }, '\xA0',

              _this.state.isSpinnerShown ?
              _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) }) :
              title)),



          _this.errorMessage()));


    }, _temp), _possibleConstructorReturn(_this, _ret);}PhoneNumberSection.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {if (!this.props.phoneNumberSent && newProps.phoneNumberSent) {if (this.state.isSpinnerShown) {this.setState({ isSpinnerShown: false, isAgainSentShown: true });} else {this.setState({ isSubmitButtonShown: false });}}if (this.props.showErrorMessage !== newProps.showErrorMessage) {this.setState({ isSpinnerShown: false });}};PhoneNumberSection.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {var _this2 = this;if (!this.state.isAgainSentShown && nextState.isAgainSentShown) {setTimeout(function () {_this2.setState({ isAgainSentShown: false, isSpinnerShown: false });}, 3000);}return true;};PhoneNumberSection.prototype.

  render = function render() {var _props =
    this.props,translate = _props.translate,phoneNumberIsInvalid = _props.phoneNumberIsInvalid,validatePhoneNumber = _props.validatePhoneNumber,onChange = _props.onChange,isMobile = _props.isMobile,isRtl = _props.isRtl;
    return (
      _react2.default.createElement('div', { className: styles.phoneSection },
        _react2.default.createElement('span', { className: styles.label }, translate('phoneNumber')),
        _react2.default.createElement('div', null,
          _react2.default.createElement(_components.OMInputField, {
            placeholder: '' + translate('phonePlaceholder'),
            name: 'phone',
            isInvalid: phoneNumberIsInvalid,
            showHoverTooltip: phoneNumberIsInvalid,
            validate: validatePhoneNumber,
            tooltipMessage: '' + translate('incorrectPhoneMessage'),
            onChange: onChange,
            isMobile: isMobile,
            maxLength: '14',
            isRtl: isRtl }),

          _react2.default.createElement(_reactAddonsCssTransitionGroup2.default, {
              transitionName: 'code-section',
              transitionEnterTimeout: 500,
              transitionLeaveTimeout: 400 },

            this.state.isSubmitButtonShown ? this.submitButton() : this.notReceiveSmsMessage()))));




  };return PhoneNumberSection;}(_react.Component);exports.default = PhoneNumberSection;


PhoneNumberSection.propTypes = {
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  validatePhoneNumber: _propTypes2.default.func,
  sendPhoneNumber: _propTypes2.default.func,
  fetchReCaptchaToken: _propTypes2.default.func,
  phoneNumberIsInvalid: _propTypes2.default.bool,
  phoneNumberSent: _propTypes2.default.bool,
  showPhonePreloader: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  showErrorMessage: _propTypes2.default.bool,
  doResetCaptcha: _propTypes2.default.bool,
  errorMessage: _propTypes2.default.string,
  phoneNumberAlreadyTaken: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  sendAgain: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PhoneVerification/Sections/PhoneNumberSection.js
// module id = 2772
// module chunks = 0